module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-quickspinland-on-up@3x.png?1.0.17";